import React, { useEffect, useState, useRef, Fragment } from 'react';
import _ from 'lodash';
import { RPCFactory } from '../../../utils/RequestUtil';
import { OneCard } from './oneCard';


const trendData = {
  total: 6,
  totalLastPeriod: 2,
  entities: [
    {
      label: '2022-07-13 08:00:00',
      value: 2,
    },
    {
      label: '2022-07-14 08:00:00',
      value: 10,
    },
    {
      label: '2022-07-15 08:00:00',
      value: 0,
    },
    {
      label: '2022-07-18 08:00:00',
      value: 40,
    },
    {
      label: '2022-07-19 08:00:00',
      value: 0,
    },
    {
      label: '2022-07-18 08:00:00',
      value: 0,
    },
    {
      label: '2022-07-19 08:00:00',
      value: 6,
    },
  ],
};
// const OneCard = (props) => {
//   const [labelList, setLabelList] = useState([]);
//   const [vlueList, setValueList] = useState([]);
//   const height = (props.height || 200) + 'px';
//   const width = (props.width || 310) + 'px';
//   useEffect(() => {
//     if (props.data && props.data.entities) {
//       setLabelList(
//         props.data.entities.map((item) => ({ value: item.label.slice(5, 10), textStyle: { fontSize: 10 } })),
//       );
//       setValueList(props.data.entities.map((item) => ({ value: item.value, textStyle: { fontSize: 10 } })));
//     }
//   }, [props.data]);
//   const option = {
//     xAxis: {
//       type: 'category',
//       data: labelList,
//     },
//     yAxis: {
//       type: 'value',
//     },
//     grid: {
//       left: '6%',
//       right: '4%',
//       bottom: '3%',
//       containLabel: true,
//     },
//     series: [
//       {
//         data: vlueList,
//         type: 'line',
//         smooth: true,
//         color: singleColor,
//         areaStyle: {
//           color: {
//             type: 'linear',
//             x: 0,
//             y: 0,
//             x2: 0,
//             y2: 1,
//             colorStops: [
//               {
//                 offset: 0,
//                 color: multipleColor[0], // 0% 处的颜色
//               },
//               {
//                 offset: 1,
//                 color: '#fff', // 100% 处的颜色
//               },
//             ],
//             global: false, // 缺省为 false
//           },
//         },
//       },
//     ],
//   };
//   const compareClass = `compare-value ${props.data && props.data.total > props.data.totalLastPeriod > 0 ? 'positive' : 'negative'
//     }`;
//   const compareValue = props.data.totalLastPeriod
//     ? (((props.data.total - props.data.totalLastPeriod) / props.data.totalLastPeriod) * 100).toFixed(2)
//     : 0;
//   return (
//     <div className="data-card">
//       <div className="card-data-part display-flex">
//         <OverlayTrigger
//           className="card-name"
//           trigger="hover"
//           alignment="right"
//           overlay={<PopOver>{props.popoverStr}</PopOver>}
//         >
//           <div className="description-and-icon">
//             {props.cardName}
//             <i className="spaui-icon icon-help"></i>
//           </div>
//         </OverlayTrigger>
//         <div className="card-value">{props.data ? props.data.total : 0}{props.isPercent ? '%' : ''}</div>
//         {!!props.data.totalLastPeriod && (
//           <div className="compare-line">
//             <span className="compare-str">环比</span>
//             <span className={compareClass}>{`${compareValue > 0 ? '+' : ''}${compareValue}%`}</span>
//           </div>
//         )}
//       </div>
//       <Echarts
//         {...option}
//         style={{
//           height,
//           width,
//         }}
//       />
//     </div>
//   );
// };

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

export const TotalAnalysis = (props) => {
  const [LeadsConnectRateData, setLeadsConnectRateData] = useState({});
  const previousParams = usePrevious(props.queryParams);
  const hideRate = Array.isArray(props.queryParams.groupIds)
    && props.queryParams.groupIds.length > 0
    || Array.isArray(props.queryParams.ownerIds)
    && props.queryParams.ownerIds.length > 0;

  useEffect(() => {
    if (hideRate) return;
    if (props.queryParams.startCreateTime && !_.isEqual(props.queryParams, previousParams)) {
      RPCFactory.leadsReport
        .getConnectionRate(props.queryParams)
        .done((data) => {
          setLeadsConnectRateData(data.trendData);
        })
        .fail((ret, msg) => {
          alert(msg);
        });
    }
  }, [props.queryParams, hideRate]);

  return (
    <div className="total-analysis">
      <OneCard
        cardName="新增线索量"
        popoverStr="统计周期内，符合上述筛选条件的线索量"
        data={props.leadsData}
        integer={true}
      ></OneCard>
      <div className="space-divider-10" />
      <OneCard
        cardName="新增接通量"
        popoverStr="统计周期内，符合上述筛选条件且接通状态为“已接通”的线索量"
        data={props.leadsFollowData}
        integer={true}
      ></OneCard>
      <div className="space-divider-10" />
      <OneCard
        cardName="有效线索量"
        popoverStr="统计周期内，符合上述筛选条件且线索状态为“已转换”的线索量"
        data={props.LeadsConversionData}
        integer={true}
      ></OneCard>
      {
        !hideRate && (
          <Fragment>
            <div className="space-divider-10" />
            <OneCard
              cardName="接通率"
              isPercent
              popoverStr="符合上述筛选条件的账户当前外呼接通率（已接通线索数/有外呼记录的线索数）"
              data={LeadsConnectRateData}
            />
          </Fragment>
        )
      }
    </div>);
};
